<ng-container [formGroup]="transactionForm">
  @if (!hideClientField() && (isOnlyOneClientInScope$ | async) === false) {
    <label class="color-gray-300 mb-2">Client</label>

    <aiwyn-autocomplete
      #clientField
      class="d-contents"
      [asyncSearchFn]="clientSearchFn$"
      [autoFocus]="true"
      [inputErrorMessage]="clientErrors()"
      [minimumSearchValueLength]="1"
      bindLabel="name"
      controlName="client"
      placeholder="Search or select a client"
    >
      <ng-template #autocompleteSharedTemplate let-item>
        {{ item.name }}
        @if (item.clientRef) {
          ({{ item.clientRef }})
        }
      </ng-template>
    </aiwyn-autocomplete>

    <div class="mb-4"></div>
  }

  @if (isNewTransactionTypePayment()) {
    <div class="d-flex gap-4 mb-4">
      <div class="w-50">
        <label class="color-gray-300 mb-2">Payment method</label>
        <mat-select
          #paymentMethodField
          class="form-input"
          disableOptionCentering
          formControlName="paymentMethodType"
          panelClass="check-select-panel"
        >
          @for (option of paymentMethodTypeOptions; track option.value) {
            <mat-option [value]="option.value">{{ option.display }}</mat-option>
          }
        </mat-select>
      </div>

      <div class="w-50">
        <label class="color-gray-300 mb-2">Bank</label>
        <aiwyn-autocomplete
          class="d-contents"
          [asyncSearchFn]="bankSearchFn$"
          [inputErrorMessage]="bankErrors()"
          [minimumSearchValueLength]="1"
          bindLabel="name"
          controlName="bank"
        />
        <div></div>
      </div>
    </div>

    <label class="color-gray-300 mb-2">Reference</label>
    <input class="form-input w-100" [inputErrorMessage]="referenceErrors()" formControlName="reference" placeholder="Type a reference" />

    <div class="d-flex justify-content-start gap-4 mt-4">
      <div class="new-transaction-date-field-wrapper">
        <label class="color-gray-300 mb-2">Transaction date</label>
        <input
          aria-label="Transaction date picker"
          class="form-input form-input--datepicker d-block"
          [ngClass]="{ 'form-input--invalid': transactionForm.errors?.depositDateBeforeTransactionDate }"
          [dpDayPicker]="transactionDatePickerConfig"
          [inputErrorMessage]="transactionDateErrors()"
          datePattern
          formControlName="transactionDate"
          placeholder="MM/DD/YYYY"
          separator="/"
        />
      </div>

      <div class="new-transaction-date-field-wrapper">
        <label class="color-gray-300 mb-2">Deposit date</label>
        <input
          aria-label="Deposit date picker"
          class="form-input form-input--datepicker d-block"
          [ngClass]="{ 'form-input--invalid': transactionForm.errors?.depositDateBeforeTransactionDate }"
          [dpDayPicker]="depositDatePickerConfig"
          [inputErrorMessage]="depositDateErrors()"
          datePattern
          formControlName="depositDate"
          placeholder="MM/DD/YYYY"
          separator="/"
        />
      </div>
    </div>
    @if (transactionForm.errors?.depositDateBeforeTransactionDate) {
      <mat-error> Deposit date must be after transaction date </mat-error>
    }
  }

  <label class="color-gray-300 mb-2" [ngClass]="{ 'mt-4': isNewTransactionTypePayment() }"> Note </label>
  <input #notesField class="form-input w-100" [inputErrorMessage]="notesErrors()" formControlName="notes" />

  @if (!isNewTransactionTypePayment()) {
    <div class="new-transaction-date-field-wrapper mt-4">
      <label class="color-gray-300 mb-2">Transaction date</label>
      <input
        aria-label="Transaction date picker"
        class="form-input form-input--datepicker d-block"
        [dpDayPicker]="transactionDatePickerConfig"
        [inputErrorMessage]="transactionDateErrors()"
        datePattern
        formControlName="transactionDate"
        placeholder="MM/DD/YYYY"
        separator="/"
      />
    </div>
  }

  <h3 class="mt-6 h3-500">{{ transactionDisplay }} details</h3>
  <div class="bg-color-gray-1100 p-4 round-1 mt-4">
    <label class="body-400 color-gray-300">Total {{ transactionDisplay | lowercase }} amount</label>
    <input
      class="form-input form-input--currency mt-2 color-gray-200"
      [inputErrorMessage]="totalErrors()"
      [maxDecimalPlaces]="2"
      (blur)="formatTotalControlValue()"
      exceptions="."
      formControlName="total"
      numberOnly
      placeholder="0.00"
    />
  </div>

  <h3 class="mt-6">Allocation</h3>

  <app-transaction-allocations
    [isEditActive]="true"
    [linkableArTrans]="linkableArTrans$ | async"
    [linkedArTrans]="{ status: LoadableStatus.LOADED, data: [] }"
    [newArTran]="newArTran$ | async"
    (pendingAllocationsChange)="onTransactionLinksChange($event)"
  />
</ng-container>
